// extracted by mini-css-extract-plugin
export var closeButton = "_g6-2";
export var closeButtonIcon = "_g6-3";
export var lightboxContent = "_g6-1";
export var lightboxOverlay = "_g6-0";